// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1JqrD","subheader":"ReorderModal_subheader__2GDEf","listWrap":"ReorderModal_listWrap__3Za43"};